import { axiosApiService } from "../axios";

const AdminQuizAPIs = {

  /* ================= GET ALL QUIZZES ================= */

  QuizListGet: async function () {
    try {
      const response = await axiosApiService.get(
        "/quiz/quizzes/"
      );

      console.log("Quiz List:", response);
      return response.data;

    } catch (error) {
      console.error(
        "Error Quiz List:",
        error.response ? error.response.data : error.message
      );
      throw error;
    }
  },

  /* ================= CREATE QUIZ ================= */

  CreateQuiz: async function (quizData) {
    try {
      const response = await axiosApiService.post(
        "training/quiz/admin/quiz/create/",
        quizData
      );

      console.log("Quiz Created:", response);
      return response.data;

    } catch (error) {
      console.error(
        "Error creating quiz:",
        error.response ? error.response.data : error.message
      );
      throw error;
    }
  },

  /* ================= DELETE QUIZ ================= */
  // ⚠️ Only works if you implement delete endpoint in backend

  DeleteQuiz: async function (quiz_id) {
    try {
      const response = await axiosApiService.delete(
        `training/quiz/admin/quiz/${quiz_id}/`
      );

      console.log("Quiz Deleted:", response);
      return response.data;

    } catch (error) {
      console.error(
        "Error deleting quiz:",
        error.response ? error.response.data : error.message
      );
      throw error;
    }
  },

  GetQuizQuestions: async function (quiz_id) {
    const response = await axiosApiService.get(
      `/quiz/quizzes/${quiz_id}/questions/`
    );
    return response.data;
  },

  UpdateQuiz: async function (quiz_id, quizData) {
    const response = await axiosApiService.put(
      `/quiz/admin/quiz/${quiz_id}/update/`,
      quizData
    );
    return response.data;
  },

};



export default AdminQuizAPIs;